import { el } from '../state/store.js';

/* The setup snapshot a feedback report carries, rendered.

   Two screens show this same data and used to carry their own copy of both
   halves: ui/feedback.js, where you check what is about to leave your
   machine, and the admin inbox, where the owner reads what arrived. The
   copies had already drifted — one label was missing from one of them — which
   is exactly the failure a shared list prevents. Only the group headings
   differ (yours/theirs), so those are the argument. */

/* Readable names for the disclosure only — the stored payload keeps its own
   keys, which are shorter and are what I read in the digest. A person
   checking what leaves their machine should not have to work out what
   "maxViewport" or "dpr" mean; a key with no entry here just shows as-is. */
export const LABELS = {
  os: 'Operating system', browser: 'Browser', mobile: 'Mobile device',
  gpu: 'Graphics card', webgl: 'WebGL', maxTexture: 'Largest texture',
  maxViewport: 'Largest render', viewport: 'Window size', display: 'Screen size',
  dpr: 'Pixel density', uiScale: 'UI scale', cores: 'Processor cores',
  memoryGB: 'Memory (GB)', language: 'Language', timezone: 'Time zone',
  online: 'Online', ua: 'Browser ID string',

  build: 'Build', stage: 'Step', view: 'View', res: 'Export size',
  screenSize: 'Screen size', setup: 'Setup', calibrated: 'Calibrated',
  objects: 'Objects', objectMix: 'Object types', supersample: 'Supersample',
  previewQuality: 'Preview quality', shadowRes: 'Shadow detail',
  lighting: 'Lighting', tone: 'Tone mapping', theme: 'Theme',
  motionBlur: 'Motion blur',
  account: 'Account', uptimeMin: 'Open for (min)'
};

/**
 * Fill `body` with the snapshot, grouped. Empty and zero values are dropped —
 * a row saying "Objects: 0" is noise in a list this long.
 *
 * @param {HTMLElement} body
 * @param {object} ctx      the snapshot, { env: {...}, app: {...} }
 * @param {Array<[string,string]>} groups  [key, heading] pairs, in order
 * @returns {boolean} whether anything was written at all
 */
export function fillContext(body, ctx, groups) {
  body.textContent = '';
  let wrote = false;
  for (const [group, label] of groups) {
    const rows = Object.entries((ctx && ctx[group]) || {})
      .filter(([, v]) => v !== '' && v !== 0);
    if (!rows.length) continue;
    wrote = true;
    body.appendChild(el('b', null, label));
    const dl = el('dl', 'fb-what-list');
    for (const [k, v] of rows) {
      dl.appendChild(el('dt', null, LABELS[k] || k));
      dl.appendChild(el('dd', null, String(v)));
    }
    body.appendChild(dl);
  }
  return wrote;
}
